import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import i18n from '../../../../i18n';
import { makeStyles } from '@material-ui/core/styles';

import { makeResetPasswordResendCodeAction } from 'state/auth/actions';
import { authResetPasswordTimeLeftSelector } from 'state/auth/selectors';

import { Text, TextTypography } from 'components/Text/Text';
import { LargeButton, LargeButtonColor } from 'components/LargeButton/LargeButton';

const useStyles = makeStyles(theme => ({
    text: {
        color: theme.palette.fixedPrimary.lighter,
    },
}));

export const Resend = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const timeLeft = useSelector(authResetPasswordTimeLeftSelector);
    const { t } = i18n.useTranslation();
    const timeLeftFormatted = String(timeLeft).padStart(2, '0');
    return timeLeft > 0 ? (
        <Text className={classes.text} typography={TextTypography.PARA}>
            {t('auth:resetPassword.code.resend', { timeLeft: `0:${timeLeftFormatted}` })}
        </Text>
    ) : (
        <LargeButton
            color={LargeButtonColor.TRANSPARENT}
            onClick={() => {
                const action = makeResetPasswordResendCodeAction();
                dispatch(action);
            }}
        >
            <Text typography={TextTypography.PARA_ACCENT}>{t('auth:resetPassword.code.resendButton')}</Text>
        </LargeButton>
    );
};
